import HBMessage from "@/components/HBMessage";
import { useLogin } from "@/components/LoginModal";
import { BuyVipDialog } from "@/components/Vip";
import useAppStore from "@/context/store";
import classNames from "classnames";
import FromDialog from "../../FormModal";
import styles from "./index.module.less";
export default function SubscriptionPackage({ config, isMobile }) {
  const { user } = useAppStore(({ user }) => ({ user }));
  const { login } = useLogin();
  const icon =
    "https://grocery-cdn.huaban.com/file/769aa030-f0a1-11ee-97bf-8784330ff257.png";
  const onBuy = (versionTab) => {
    if (isMobile) {
      navigator.clipboard.writeText(`${location.origin}/vip/info`);
      HBMessage.success("复制成功");
      return;
    }
    if (!user) {
      login({
        source_location: "购买弹窗",
      });
      return;
    }
    // BuyVipDialog.open({});
    BuyVipDialog.open({
      type: "company",
      versionTab: versionTab,
      isGdDialog: true,
    });
  };
  const openFrom = () => {
    FromDialog.open({
      config,
      isMobile,
    });
  };
  const list = [() => onBuy(0), () => onBuy(1), openFrom];
  return (
    <>
      <h2 className={styles.title}>
        <span>企业素材</span>定制购买套餐
      </h2>
      <div className={styles.subTitle}>
        满足多主体授权适用于广告/建站/代运营等第三方公司
      </div>
      <div className={styles.content}>
        {config?.subscription?.map((item, index) => {
          return (
            <div
              className={classNames(styles.item, {
                [styles.special]: index === 2,
              })}
              key={index}
            >
              <div className={styles.header}>
                <span className={styles.itemTitle}>{item.title}</span>
                <span className={styles.itemDesc}>{item.desc}</span>
                <div
                  onClick={list[index]}
                  className={styles.btn}
                  data-gd-click="button_click"
                  data-gd-expose="button_expose"
                  data-module-name="商品展示栏"
                  data-subject-name="按钮"
                  data-button-name={
                    isMobile ? item.mobileBtnName : item.btnName
                  }
                >
                  <div className={styles.btnText}>
                    {isMobile ? item.mobileBtnName : item.btnName}
                  </div>
                </div>
              </div>

              <div className={styles.tagConent}>
                {item?.tags?.map((tag, index) => {
                  return (
                    <div className={styles.tag} key={index}>
                      <img src={icon} alt="" width={20} />
                      <div> {tag}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
}
